module.exports = __webpack_public_path__ + "media/images/athletes/3581-06aa9c49726760593bf3278091c653c8.png";